import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Context } from '../controls/advanced-gridview/models/context';
import { FilterInfos } from '../controls/advanced-gridview/models/filter-infos';
import { Results } from '../controls/advanced-gridview/models/results-T';
import { SortInfos } from '../controls/advanced-gridview/models/sort-infos';
import { AdvancedService } from '../controls/advanced-gridview/services/advanced-service';
import { Customer } from '../models/customer';
import { CrudService } from './crud-service';
import { MemoryService } from './memory.service';

@Injectable({
    providedIn: 'root',
})
export class CustomersService extends CrudService implements AdvancedService<Customer> {
    constructor(
        private http: HttpClient,
        public override memoryService: MemoryService
    ) {
        super(memoryService);
    }

    List(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos, pageNumber = 0, pageSize = 100): Observable<Results<Customer>> {
        let params = new Map<string, string | number | boolean>();
        params.set('from', pageNumber);
        params.set('size', pageSize);

        const httpOptions = this.getListHttpOptions(context, filters, generalFilters, sortInfos, params);

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/organizations/${this.organizationId}/customers`, httpOptions).pipe(
            map((x) => {
                var res = Results.getCopyFrom<Customer>(Customer, x);

                return res;
            })
        );
    }

    Export(context: Context, filters: FilterInfos[], generalFilters: FilterInfos[], sortInfos: SortInfos): Observable<Blob> {
        const headers = this.getExportHeader(context, filters, generalFilters, sortInfos);

        // Appel de la Web Api
        return this.http.get(this.baseUrl + `/api/organizations/${this.organizationId}/customers/export`, { headers: headers, responseType: 'blob' }).pipe(
            map((res: any) => {
                const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                return blob;
            })
        );
    }

    update(customerId: number, customer: Customer): Observable<Customer> {
        // Appel de la Web Api
        return this.http.put<Customer>(this.baseUrl + `/api/organizations/${this.organizationId}/customers/${customerId}`, customer, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return x;
            })
        );
    }

    delete(customerId: number): Observable<boolean> {
        // Appel de la Web Api
        return this.http.delete<Customer>(this.baseUrl + `/api/organizations/${this.organizationId}/customers/${customerId}`, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return true;
            })
        );
    }

    add(customer: Customer): Observable<Customer> {
        customer.organizationId = this.organizationId;
        // Appel de la Web Api
        return this.http.post<Customer>(this.baseUrl + `/api/organizations/${this.organizationId}/customers`, customer, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return x;
            })
        );
    }

    get(customerId: number): Observable<Customer> {
        // Appel de la Web Api
        return this.http.get<Customer>(this.baseUrl + `/api/organizations/${this.organizationId}/customers/${customerId}`, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                return x;
            })
        );
    }
}
